// components/HomeHighlightsCarousel.js
import React, {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchHomeHighlights } from "../redux/actions/admin/homeHighlightsAction";
import Slider from "react-slick";
import { Box, Typography, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

// Custom styled components
const CarouselContainer = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  padding: theme.spacing(3),
  backgroundColor: "#f9f9f9",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
   overflow: "hidden",
}));

const ImageCard = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "320px", // Passport size से बड़ा (पासपोर्ट आमतौर पर 2x2 inch या 51x51 mm)
  // width: "380px", // Width भी थोड़ा ज्यादा
width: {sm: "210px", md: "240px", lg: "310px"},
  margin: "0 auto",
  borderRadius: "12px",
  overflow: "hidden",
  boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
  },
}));

const StyledImage = styled("img")({
  width: "100%",
  height: "100%",
  // objectFit: "cover", 
//   objectPosition: "center",
  objectPosition: "top center",
});

const Overlay = styled(Box)({
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
  padding: "16px",
  color: "white",
});

const HomeHighlightsCarousel = () => {
   const dispatch = useDispatch();
  const { homeHighlights: images = [], loading = false } = useSelector(
    (state) => state.homeHighlights || {}
  );

    useEffect(() => {
      dispatch(fetchHomeHighlights());
    }, [dispatch]);
  // Slick carousel settings
  const settings = {
    // dots: true,
    infinite: images?.length > 1,
    speed: 500,
    slidesToShow: 4, 
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1370,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={5}>
        <CircularProgress />
      </Box>
    );
  }

  if (!images || images.length === 0) {
    return (
      <Box textAlign="center" py={5}>
        <Typography variant="h6" color="textSecondary">
          No highlights images available
        </Typography>
      </Box>
    );
  }

  return (
    <CarouselContainer>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 700,
          color: "#065A79",
          mb: 4,
          letterSpacing: "1px",
        }}
      >
        Top Performing Students
      </Typography>
      
      <Slider {...settings}>
        {images.map((image, index) => (
          <Box key={index} sx={{ px: 2 }}>
            <ImageCard>
              <StyledImage
                src={image.imageUrl || image.url || image}
                alt={`School highlight ${index + 1}`}
                loading="lazy"
              />
              {/* <Overlay>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 600,
                    fontSize: "1rem",
                    textShadow: "1px 1px 3px rgba(0,0,0,0.8)",
                  }}
                >
                  Shree Mangalam School
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.85rem",
                    opacity: 0.9,
                  }}
                >
                  Activity #{index + 1}
                </Typography>
              </Overlay> */}
            </ImageCard>
          </Box>
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default HomeHighlightsCarousel;